var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', _vm._b({
    staticClass: "d-flex flex-column flex-sm-row align-stretch justify-center justify-sm-start rounded-lg text-decoration-none mt-4 pa-4",
    attrs: {
      "max-width": "850",
      "width": "100%"
    }
  }, 'v-sheet', Object.assign({}, _vm.cardProps), false), [_c('v-sheet', {
    staticClass: "d-flex align-start justify-center mx-auto mx-sm-0 mb-2 mb-sm-0 mr-sm-4 mr-md-0",
    attrs: {
      "height": "100%",
      "max-width": "33%",
      "min-width": "33%",
      "width": "33%"
    }
  }, [_c('img', {
    staticClass: "item-logo rounded-lg",
    attrs: {
      "src": _vm.item.img,
      "alt": ("logo for " + (_vm.item.title))
    }
  })]), _c('v-card', {
    staticClass: "d-flex flex-column text-decoration-none",
    attrs: {
      "flat": "",
      "title": ""
    }
  }, [_c('v-card-title', {
    staticClass: "text-h5 primary--text font-weight-bold break-word text-decoration-none pa-0",
    domProps: {
      "innerHTML": _vm._s(_vm.item.title)
    }
  }), _c('v-card-text', {
    staticClass: "d-flex flex-column align-start justify-start text-decoration-none pa-0"
  }, [_c('p', {
    staticClass: "text-body-1 font-weight-bold py-4 py-sm-8"
  }, [_vm._v(_vm._s(_vm.item.details || ' '))])])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }